import { render, staticRenderFns } from "./pageMode1.vue?vue&type=template&id=2e60577a"
import script from "./pageMode1.vue?vue&type=script&lang=js"
export * from "./pageMode1.vue?vue&type=script&lang=js"
import style0 from "./pageMode1.vue?vue&type=style&index=0&id=2e60577a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports